import * as marietta from '../../..';
import * as marietta3d from '../../../view3d';
import { Dialog } from '../../../core/view';

/**
 * 3Dー表示設定ダイアログ
 * ※種別毎の表示ON/OFFの設定が行える
 */
export default class Item3dDisplayDialog extends Dialog {
  /**
     * コンストラクタ
    */
  constructor(draggable: boolean) {
    super(draggable);

    // ダイアログのコンテンツ生成
    const id = 'Item3dDisplayDialog';
    // タイトル
    let title = '';
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'en': title = 'Display Item'; break;
      default: title = '表示アイテム'; break;
    }
    let contents = '<div class="item3dDisplayDialog">\n';
    contents += '<table>\n';
    contents += '<tbody id="Item3dDisplayList">\n';
    contents += '</tbody>\n';
    contents += '</table>\n';
    contents += '</div>';
    let footer = '<button id="btnDoneCustomizeDisplay"><span class="jp">ＯＫ</span><span class="en">OK</span></button>';
    footer += '<button id="btnClose"><span class="jp">キャンセル</span><span class="en">Cancel</span></button>';

    this.createDialog(id, title, contents, footer);

    this.createItemList();

    // イベント設定
    // OKButtonクリックをトリガー
    const btn = document.querySelector('#btnDoneCustomizeDisplay');
    btn.addEventListener('click', this.btnEventHandler);

    // closeButtonクリックをトリガー
    document.getElementById('btnClose').addEventListener('click', () => {
      marietta.webcad.WebCADGlobal.removeDialog();
    });
  }

  // creating 3d menu list
  createItemList= () => {
    const itemList = marietta3d.webcad.View3dGlobal.shared.partType;
    const target = document.querySelector('#Item3dDisplayList');
    const trElem = document.createElement('tr');
    const thElem = document.createElement('th');
    const labelElem = document.createElement('label');
    trElem.append(thElem);
    let disableRoof = true;
    let disableCeiling = true;
    const objects = marietta3d.webcad.ThreeView.get().wcItemmgr.getAllFloorObjects();
    for (let i = 0; i < objects.length; i += 1) {
      const object = <THREE.Object3D>objects[i];
      if (object.userData.layer && object.userData.layer.indexOf('R') > -1 && (Number(object.userData.layer.substring(1, 2)) < marietta3d.webcad.ThreeView.get().wcItemmgr.floorsObjects.floor)) {
        disableRoof = false;
      }
      if (objects[i].name.indexOf('ceiling') > -1) {
        disableCeiling = false;
      }
    }
    for (let i = 0, len = itemList.length; i < len; i += 1) {
      const el = trElem.cloneNode(true);
      const lblElm = labelElem.cloneNode(true);
      const chkBox = document.createElement('input');
      chkBox.setAttribute('type', 'checkbox');
      chkBox.setAttribute('id', `3dDisplay_${itemList[i].id}`);
      chkBox.checked = itemList[i].visible;
      if (itemList[i].id === marietta3d.webcad.webcadDefines.PartType.roof && disableRoof) {
        chkBox.disabled = true;
        chkBox.checked = false;
        (<any>el).classList.add('disabled');
      }
      if (itemList[i].id === marietta3d.webcad.webcadDefines.PartType.ceiling && disableCeiling) {
        chkBox.disabled = true;
        chkBox.checked = false;
        (<any>el).classList.add('disabled');
      }
      const parser = new DOMParser();
      (<HTMLElement>lblElm).setAttribute('for', `3dDisplay_${itemList[i].id}`);
      const TestHtml = `<span class="jp">${itemList[i].jp}</span><span class="en">${itemList[i].en}</span>`;
      lblElm.appendChild(parser.parseFromString(TestHtml, 'text/html').body.children[0]);
      lblElm.appendChild(parser.parseFromString(TestHtml, 'text/html').body.children[1]);
      (<any>el).querySelector('th').append(chkBox);
      (<any>el).querySelector('th').append(lblElm);
      target.append(el);
    }
  }

  /**
   * OKボタンがクリック
   * @return void
   * @param e => mouse event
  */
  btnEventHandler = (e: any) => {
    e.preventDefault();
    document.getElementById('Item3dDisplayList').querySelectorAll('input').forEach((param) => {
      const itemList = marietta3d.webcad.View3dGlobal.shared.partType;
      for (let i = 0, len = itemList.length; i < len; i += 1) {
        if (param.id === `3dDisplay_${itemList[i].id}`) {
          itemList[i].visible = param.checked;
        }
      }
    });
    marietta3d.webcad.View3dGlobal.shared.setItemDisplay();
    // パネルを閉じる
    marietta.webcad.WebCADGlobal.removeDialog();
  }
}
